import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import Dropdown from "../components/Dropdown";
import { useTranslation } from "react-i18next";
import { createArray } from "./analyseData/columns.config";
import {
  uploadSelectedSheet,
  getPlantDetails,
  getColumnMapping,
} from "../network/cipAPI";
import {
  storeFileId,
  updateSelectedTrain,
  storeDefaultInformation,
} from "../Store/TemplateStore/template.action";
import { extractPlantId } from "../utils/Utils";
import createNotification, {
  ERROR_NOTIFICATION,
} from "../components/Notifications";

const FileUpload = React.forwardRef(
  ({
    setFileId,
    setColumnsOptions,
    fileInfo,
    selectedTrain,
    config,
    setMappedColumn,
    setSheetNames,
    setMappedReference,
    sheetNames,
    selectedSheet,
    setSelectedSheet,
    setSelectedTrain,
    setSelectedCIPFileName,
    setHasRecurrentCIPs,
    disableTrain,
    setIsLoading,
    setIsProceedDisabled,
    setIsAppendFile,
    setAppendFileName,
    setAppendStatus,
  }) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const [selectedTrainOption, setSelectedTrainOption] =
      useState(selectedTrain);
    const plantId = extractPlantId();
    useEffect(() => {
      setSelectedTrainOption(selectedTrain);
    }, [selectedTrain]);

    useEffect(() => {
      if (!sheetNames || sheetNames.length === 0) {
        setIsProceedDisabled(true);
      }
    }, [sheetNames]);

    const resetState = () => {
      setFileId(null);
      setMappedColumn([]);
      setMappedReference(null);
      setIsLoading(false);
    };

    const handleTrainOptionChange = async (value) => {
      setSelectedTrainOption(value);
      setSelectedCIPFileName(null);
      setHasRecurrentCIPs(false);
      setIsAppendFile(false);
      setAppendFileName(null);
      setIsLoading(true);
      console.log("Selected Train:", value);

      if (!value) {
        resetState();
        setSelectedTrain(null);
        setSelectedSheet(null);
        return;
      }
      try {
        const response = await getPlantDetails(plantId, true, value);
        if (response && response.data) {
          const {
            file,
            parent_file_name,
            default_cip,
            col_mapping,
            sel_train,
            bulk_cip_file_name,
            has_recurrent_cips,
            sheet_names,
            ref_condition,
            analysis,
            isAppended,
            append_file_name,
          } = response.data;
          let file_id, sheet_name;
          if (file) {
            ({ file_id, sheet_name } = file);
          }

          setFileId(file_id);
          const fileInfo1 = {
            file_id,
            sheetName: sheet_name,
            fileName: parent_file_name,
          };
          dispatch(storeFileId(fileInfo1));

          if (default_cip) {
            dispatch(storeDefaultInformation(default_cip));
          }
          setMappedColumn(col_mapping);
          setSelectedTrain(sel_train);
          setSelectedCIPFileName(bulk_cip_file_name);
          setHasRecurrentCIPs(has_recurrent_cips);
          setIsAppendFile(isAppended);
          setAppendFileName(append_file_name);
          setAppendStatus("success");
          setIsProceedDisabled(!analysis);
          dispatch(updateSelectedTrain(sel_train));
          setSheetNames(sheet_names);
          setSelectedSheet(sheet_name);
          setMappedReference(ref_condition[0]);
          if (file_id) {
            const columns = await getColumnMapping(file_id, sel_train);
            if (columns && columns.data) {
              setColumnsOptions(columns.data?.cols);
            }
          }
          if (sheet_names && sheet_names.length === 1) {
            if (!file_id) {
              const response = await uploadSelectedSheet(
                value,
                encodeURIComponent(fileInfo.fileName),
                sheet_names[0]
              );
              setColumnsOptions(response?.cols);
              setFileId(response?.file_id);
              dispatch({
                type: "STORE_FILE_ID",
                payload: {
                  file_id: response?.file_id,
                },
              });
            }
          }
        }
      } catch (err) {
        console.log("getPlantDetail..", err);
        createNotification(
          ERROR_NOTIFICATION,
          t("notificationStrings.somethingWrong"),
          ""
        );
        resetState();
        setSelectedSheet(null);
        setSelectedCIPFileName(null);
        setHasRecurrentCIPs(false);
        setIsAppendFile(false);
      } finally {
        setIsLoading(false);
      }
    };

    const handleOptionChange = async (value) => {
      setSelectedSheet(value);
      setIsProceedDisabled(true);
      if (!value) {
        resetState();
        setSelectedSheet(null);
        return;
      }
      setIsLoading(true);
      setMappedColumn([]);
      setMappedReference(null);
      try {
        const response = await uploadSelectedSheet(
          selectedTrain,
          encodeURIComponent(fileInfo.fileName),
          value
        );
        setColumnsOptions(response?.cols);
        setFileId(response?.file_id);
        dispatch({
          type: "STORE_FILE_ID",
          payload: {
            file_id: response?.file_id,
          },
        });
      } catch (error) {
        console.error("Error during API call:", error);
      } finally {
        setIsLoading(false);
      }
    };

    return (
      <div
        className="lightGrayBorder"
        style={{ padding: "10px", marginTop: "10px" }}
      >
        <div className="grid-container-row">
          <Dropdown
            labelText={t("addNewPlant.sel_train")}
            key={"sel_train"}
            options={createArray(config?.trains?.length, "sel_train", true)}
            onChange={(value) => {
              handleTrainOptionChange(value);
            }}
            value={selectedTrainOption}
            disabled={disableTrain}
          />
          {sheetNames?.length > 1 && (
            <Dropdown
              labelText={t("addNewPlant.selSheet")}
              options={sheetNames}
              onChange={(value) => {
                handleOptionChange(value);
              }}
              value={selectedSheet}
              disabled={!selectedTrainOption}
            />
          )}
        </div>
      </div>
    );
  }
);

export default FileUpload;
